import CustomerService from "@/services/CustomerService.js";

const state = {
  customerList: [],
  customer: {
    _id: null,
    kdnr: "",
    name: "",
    telefon: "",
    email: "",
    adresse: "",
    plz: "",
    ort: "",
    land: "AT",
    arbeitstage: [1, 2, 3, 4, 5],
    schichtbetrieb: false,
    standort: "",
    roboter: false,
    roboterId: "",
    grossgebinde: false,
    restekarte: false,
    restekarteMaxTage: 4,
    manageLieferorte: false,
    exportOrders: true,
    bestellendeTag: "3",
    bestellendeZeit: "12:00",
    branding: {
      _id: null,
      hostname: "",
      logo: "",
      css: "",
      active: false,
      theme: {
        primary: "",
        secondary: "",
        accent: "",
        error: "",
        warning: "",
        info: "",
        success: "",
      },
    },
    mahlzeiten: [
      {
        active: true,
        von: "00:00",
        bis: "23:59",
      },
      {
        active: false,
        von: "",
        bis: "",
      },
      {
        active: false,
        von: "",
        bis: "",
      },
      {
        active: false,
        von: "",
        bis: "",
      },
    ],
    essenskosten: [
      {
        name: "default",
        amount: 0,
        type: 0,
        perItem: 0,
        limits: {
          hiddenCategories: [],
          vorspeisen: {
            amount: 0,
          },
          hauptspeisen: {
            amount: 0,
          },
          desserts: {
            amount: 0,
          },
        },
      },
    ],
  },
};

const getters = {
  getCustomerList(state) {
    return state.customerList;
  },
  getCurrent(state) {
    return state.customer;
  },
};

const actions = {
  findCustomers(name) {
    console.log("Search: " + name);
    return new Promise((resolve, reject) => {
      CustomerService.findCustomers(name)
        .then((result) => {
          resolve(result);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  getLastID() {
    return new Promise((resolve, reject) => {
      CustomerService.getLastItem()
        .then((result) => {
          if (result && result.data && result.data.item) {
            resolve(result.data.item.kdnr);
          } else {
            resolve(null);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  fetchCustomerList({ commit }) {
    return new Promise((resolve, reject) => {
      CustomerService.getAll()
        .then((response) => {
          commit("SET_CUSTOMER_LIST", response.data.data);
          resolve(response.data.data);
        })
        .catch((error) => {
          //console.log(error.response.data.error);
          reject(error);
        });
    });
  },
  fetchCustomer({ commit }, id) {
    return new Promise((resolve, reject) => {
      CustomerService.get(id)
        .then((response) => {
          commit("SET_CUSTOMER", response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  save({ commit, state }) {
    return new Promise((resolve, reject) => {
      if (state.customer) {
        const subsidy = {
          id: state.customer._id,
          data: state.customer,
        };
        CustomerService.save(subsidy)
          .then((result) => {
            commit("SET_CUSTOMER", result.data.data);
            resolve(result.data.data);
          })
          .catch((error) => {
            reject(error);
          });
      } else {
        reject("Kundendaten nicht geladen");
      }
    });
  },
  deleteCustomer({ commit }, id) {
    return new Promise((resolve, reject) => {
      CustomerService.delete(id)
        .then((result) => {
          commit("REMOVE_CUSTOMER", id);
          resolve(result);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
};

const mutations = {
  SET_CUSTOMER_LIST(state, value) {
    state.customerList = value;
  },
  SET_CUSTOMER(state, value) {
    state.customer = value;
  },
  REMOVE_CUSTOMER(state, id) {
    state.customerList = state.customerList.filter((item) => item._id !== id);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
